import axios from "axios";

export const engApi = axios.create({
  baseURL: "https://eng.buu.ac.th/internship/intern-api",
});

engApi.interceptors.request.use(
  async (config) => {
    // store.dispatch(updateIsLoading(true));

    return config;
  },
  (error) => {
    // store.dispatch(updateIsLoading(false));
    return Promise.reject(error);
  }
);

engApi.interceptors.response.use(
  (response) => {
    // store.dispatch(updateIsLoading(false));

    return response;
  },
  async (error) => {
    // store.dispatch(updateIsLoading(false));

    return Promise.reject(
      (error.response && error.response.data) || "Wrong Services"
    );
  }
);
